/**
 * Auth callback handler for social login
 * This file handles the callback from social login providers
 */

/**
 * Parse the URL hash fragment for auth data
 * @returns {Object|null} The parsed auth data or null if none found
 */
export function parseAuthCallbackData() {
  // Check if we're on the auth-callback page
  if (!window.location.href.includes('/auth-callback')) {
    return null;
  }
  
  // Get the hash fragment (everything after #)
  const hashFragment = window.location.hash.substring(1);
  if (!hashFragment) {
    return null;
  }
  
  try {
    // Decode and parse the JSON data
    const decodedData = decodeURIComponent(hashFragment);
    return JSON.parse(decodedData);
  } catch (e) {
    console.error('Failed to parse auth callback data:', e);
    return null;
  }
}

/**
 * Process the auth callback and notify the parent window
 * @returns {Object|null} The parsed auth data or null if none found
 */
export function processAuthCallback() {
  const authData = parseAuthCallbackData();
  if (!authData) {
    console.log('No auth data found in URL');
    return null;
  }
  
  console.log('Processing auth callback data:', authData);
  
  // Add isVowEvent flag if not present
  if (authData.isVowEvent === undefined) {
    authData.isVowEvent = true;
  }
  
  // Add type if not present
  if (authData.type === undefined) {
    authData.type = 'social_auth_result';
  }
  
  // Post message to parent window
  // if (window.opener) {
  //   try {
  //     window.opener.postMessage(authData, '*');
  //     console.log('Auth data posted to parent window');
      
  //     // Close this window after a short delay
  //     setTimeout(() => {
  //       window.close();
  //     }, 1000);
      
  //     return authData;
  //   } catch (e) {
  //     console.error('Failed to post message to parent window:', e);
  //     return authData;
  //   }
  // } else {
    console.log('No parent window found, processing auth data directly');
    
    // Process the auth data directly
    if (authData.accessToken) {
      // Store the token in localStorage
      localStorage.setItem("user-token", authData.accessToken.access_token);
      setTimeout(() => {
        window.location.href = '/'
      }, 100)
      // Set up axios headers if available
      // if (window.axios) {
      //   window.axios.defaults.headers.common["Authorization"] = 
      //     authData.accessToken.access_token;
      // }
      
      // If we have access to the store, dispatch user request and wait for it
      // if (window.store) {
      //   window.store.dispatch('USER_REQUEST').then(() => {
      //     // Redirect after user data has been stored
      //     window.location.href = '/';
      //   }).catch(error => {
      //     console.error('Error fetching user data:', error);
      //     // Redirect anyway after a delay
      //     setTimeout(() => {
      //       window.location.href = '/';
      //     }, 1000);
      //   });
      // } else {
      //   // If no store access, redirect after a delay
      //   setTimeout(() => {
      //     window.location.href = '/';
      //   }, 1000);
      // }
    } else if (authData.result === false) {
      // Handle error case
      console.error('Authentication failed:', authData.err);
      
      // Redirect to login page after error
      setTimeout(() => {
        window.location.href = '/login';
      }, 2000);
    }
    
    return authData;
  // }
}

/**
 * Initialize auth callback handler
 * Call this function when the application starts
 */
export function initAuthCallbackHandler() {
  const { checkSocialLoginReturn, cleanupSocialLoginData } = require('./socialLogin');
  
  // Check if we're on the auth-callback page
  if (window.location.href.includes('/auth-callback')) {
    console.log('Auth callback page detected, processing...');
    processAuthCallback();
    return;
  }
  
  // Check if we're returning from a social login redirect
  if (checkSocialLoginReturn()) {
    console.log('Returning from social login redirect');
    
    // Get the return URL
    const returnUrl = localStorage.getItem('socialLoginReturnUrl');
    // setTimeout(() => {
    //   window.location.href = returnUrl;
    // }, 10000)
    // Clean up social login data
    cleanupSocialLoginData();
    
    // If we have a token, we're logged in
    // if (localStorage.getItem('user-token')) {
    //   console.log('User is logged in, refreshing user data');
      
    //   // Dispatch user request to get user data
    //   if (window.store) {
    //     window.store.dispatch('USER_REQUEST');
    //   }
    // }
  }
}
